import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultFieldset: {
    id: 'menuSection.defaultFieldset',
    defaultMessage: 'Default',
  },
  blockTitle: {
    id: 'menuSection.blockTitle',
    defaultMessage: 'Section carte',
  },
  eyebrow: {
    id: 'menuSection.eyebrow',
    defaultMessage: 'Sur-titre',
  },
  title: {
    id: 'menuSection.title',
    defaultMessage: 'Titre',
  },
  countLabel: {
    id: 'menuSection.countLabel',
    defaultMessage: 'Compteur',
  },
  headerImage: {
    id: 'menuSection.headerImage',
    defaultMessage: 'Image de section (optionnelle)',
  },
  headerImageDescription: {
    id: 'menuSection.headerImageDescription',
    defaultMessage:
      'Bandeau affiché au-dessus du titre de la section. Format conseillé : paysage 3:2.',
  },
  showAllergenNotice: {
    id: 'menuSection.showAllergenNotice',
    defaultMessage: 'Afficher la mention allergènes',
  },
  items: {
    id: 'menuSection.items',
    defaultMessage: 'Plats',
  },
  itemTitle: {
    id: 'menuSection.itemTitle',
    defaultMessage: 'Plat',
  },
  addItem: {
    id: 'menuSection.addItem',
    defaultMessage: 'Ajouter un plat',
  },
  name: {
    id: 'menuSection.name',
    defaultMessage: 'Nom',
  },
  description: {
    id: 'menuSection.description',
    defaultMessage: 'Description',
  },
  allergens: {
    id: 'menuSection.allergens',
    defaultMessage: 'Tags / allergènes',
  },
  allergensDescription: {
    id: 'menuSection.allergensDescription',
    defaultMessage:
      'Étiquettes libres affichées sous la description (ex. « vegan », « sans gluten », « fait maison »).',
  },
  price: {
    id: 'menuSection.price',
    defaultMessage: 'Prix',
  },
  priceSupplement: {
    id: 'menuSection.priceSupplement',
    defaultMessage: 'Supplément',
  },
  priceAccent: {
    id: 'menuSection.priceAccent',
    defaultMessage: 'Mettre le prix en accent',
  },
  fullWidth: {
    id: 'menuSection.fullWidth',
    defaultMessage: 'Afficher en pleine largeur',
  },
  itemImage: {
    id: 'menuSection.itemImage',
    defaultMessage: 'Image du plat (optionnelle)',
  },
  eyebrowPlaceholder: {
    id: 'menuSection.eyebrowPlaceholder',
    defaultMessage: 'Sur-titre (Entrées…)',
  },
  sectionTitlePlaceholder: {
    id: 'menuSection.sectionTitlePlaceholder',
    defaultMessage: 'Titre de la section',
  },
  countLabelPlaceholder: {
    id: 'menuSection.countLabelPlaceholder',
    defaultMessage: 'Compteur (5 plats…)',
  },
  dishTitlePlaceholder: {
    id: 'menuSection.dishTitlePlaceholder',
    defaultMessage: 'Nom du plat',
  },
  dishDescriptionPlaceholder: {
    id: 'menuSection.dishDescriptionPlaceholder',
    defaultMessage: 'Description : ingrédients, accord, provenance…',
  },
  dishTagsAriaLabel: {
    id: 'menuSection.dishTagsAriaLabel',
    defaultMessage: 'Étiquettes du plat',
  },
  pricePlaceholder: {
    id: 'menuSection.pricePlaceholder',
    defaultMessage: '0 €',
  },
  priceAriaLabel: {
    id: 'menuSection.priceAriaLabel',
    defaultMessage: 'Prix',
  },
  priceSupplementPlaceholder: {
    id: 'menuSection.priceSupplementPlaceholder',
    defaultMessage: 'suppl. +0 €',
  },
  priceSupplementAriaLabel: {
    id: 'menuSection.priceSupplementAriaLabel',
    defaultMessage: 'Supplément',
  },
  removeDish: {
    id: 'menuSection.removeDish',
    defaultMessage: 'Supprimer {title}',
  },
  removeDishFallback: {
    id: 'menuSection.removeDishFallback',
    defaultMessage: 'le plat',
  },
  emptyState: {
    id: 'menuSection.emptyState',
    defaultMessage:
      'Aucun plat pour l’instant. Cliquez sur « + Ajouter un plat ».',
  },
  addDishButton: {
    id: 'menuSection.addDishButton',
    defaultMessage: '+ Ajouter un plat',
  },
  allergenNotice: {
    id: 'menuSection.allergenNotice',
    defaultMessage:
      'Certains de nos plats contiennent des allergènes. Merci de signaler toute allergie ou intolérance à votre serveur avant de commander.',
  },
});

export default messages;
